import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import Slider from 'react-slick'
import { ImageUrl } from '../../../../../../Helpers/request'

const MiClintSlider = () => {
    const settingsClintSlider = {
        dots: false,
        infinite: true,
        autoplay: true,
        arrows:false,
        focusOnSelect:false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                initialSlide: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ],
          beforeChange: (current, next) => {
            document
              .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
              .forEach(el => el.setAttribute('tabindex', '-1'));
          },
          afterChange: () => {
            document
              .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
              .forEach(el => el.removeAttribute('tabindex'));
          }
      };

      const clientImg = [
        {
            cImg: `${ImageUrl}home/google.webp` ,
            cName:"google",
            cUrl:"#",
        },
        {
            cImg:`${ImageUrl}home/rapnet.webp` ,
            cName:"rapnet",
            cUrl:"#",
        },
        {
            cImg:`${ImageUrl}home/overnight.webp` ,
            cName:"overnight",
            cUrl:"#",
        },
        {
            cImg: `${ImageUrl}home/stuller.png` ,
            cName:"stuller",
            cUrl:"#",
        },
        {
            cImg:`${ImageUrl}home/vdb.webp` ,
            cName:"vdb",
            cUrl:"#",
        },
        {
            cImg:`${ImageUrl}home/ivouch.webp` ,
            cName:"ivouch",
            cUrl:"#",
        },
        {
            cImg:`${ImageUrl}home/yelp.webp` ,
            cName:"yelp",
            cUrl:"",
        },
       
      ]
       
      


  return (
    <>
       <div className='mi_client_slider'>
              <Container fluid> 
                  <Row>
                    <Col sm={12} md={12} lg={12}>
                    <Slider {...settingsClintSlider} className='mi_client_slider'>
                        {clientImg.map((val)=>(
                            <div className='mi_client_slider_img_box'>
                           <Image src={val.cImg} className="mi_client_slider_img" alt={val.cName + " Image"}/>
                        </div>
                        ))}
                        </Slider>
                    </Col>
                  </Row>
              </Container>
       </div>
    </>
  )
}

export default MiClintSlider
